module.exports = __webpack_public_path__ + "img/img1.7bd54452.svg";